import { render, staticRenderFns } from "./servicechat.vue?vue&type=template&id=80508a78&scoped=true&"
import script from "./servicechat.vue?vue&type=script&lang=js&"
export * from "./servicechat.vue?vue&type=script&lang=js&"
import style0 from "./servicechat.vue?vue&type=style&index=0&id=80508a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80508a78",
  null
  
)

export default component.exports